import React, { FC, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { DateTime } from 'luxon';
import Hyperlink from '@ingka/hyperlink';
import { Layout } from '@pcmp/react-coworker-components';

import { useGetShortLink } from '@/lib/hooks/qrcode';
import { COUNTRIES } from '@/lib/constants';

import { CodeActions } from './actions';
import { useCode } from '../../create-code/context';

const { Container } = Layout;

const CodeField: FC<{
  title: string;
  content: string | ReactElement;
}> = ({ title, content }) => {
  return (
    <div className="text-sm">
      <p className="font-bold">{title}</p>
      <p className="text-skapa-text-2 mt-2">{content}</p>
    </div>
  );
};

export const DetailedCodeHeader: FC = () => {
  const { t } = useTranslation();
  const { code } = useCode();
  const getShortLink = useGetShortLink();
  const shortlink = getShortLink(code);

  const country =
    COUNTRIES.find((c) => c.value === code.user.country)?.text ||
    code.user.country ||
    '';

  return (
    <div className="w-full bg-skapa-elevation-2 p-6">
      <Container className="pt-6">
        <div className="flex flex-row w-full align-between gap-1">
          <div className="flex flex-row w-full gap-8">
            <div className="flex flex-col sm:flex-row gap-5">
              <CodeField title="Slug" content={code.slug || ''} />

              <CodeField
                title={t('label.code.codeName')}
                content={code.codeName}
              />
              <CodeField
                title={t('label.code.targetUrl')}
                content={
                  <Hyperlink
                    url={shortlink}
                    text={t('label.clickToAccess')}
                    target="_blank"
                  />
                }
              />
              <CodeField
                title={t('label.code.creationDate')}
                content={
                  DateTime.fromISO(code.created).toFormat('yyyy.MM.dd hh:mm') ||
                  ''
                }
              />
            </div>
            <div className="flex flex-col sm:flex-row gap-5">
              <CodeField
                title={t('label.code.owner')}
                content={code.user.name || code.user.email}
              />
              <CodeField title={t('label.code.country')} content={country} />
              <CodeField
                title={t('label.code.site')}
                content={code.user.location}
              />
            </div>
          </div>
          <CodeActions code={code} />
        </div>
      </Container>
    </div>
  );
};
